<template>
    <ul :class="['articel_list', { paddingTop: hasBannerData }]" ref="mouseWheelRf">
      <!-- tab -->
      <div class="h_agq_page_chatting_wrap_nav">
        <div>
          <button :class="[{
            bind_this: liveDefault == 'list_msg',
          }]" @click.stop.prevent="checkLiveDefault('list_msg')">全部</button>
          <button :class="[{
            bind_this: liveDefault == 'my_msg',
          }]" @click.stop.prevent="checkLiveDefault('my_msg')">我的消息</button>
        </div>
      </div>
  
      <drop-down-refresh :onRefresh="onRefresh" :dropDownInfo='{
        downText: "下拉可以加载",
        downImg: "arrow.png",
        upText: "松开立即加载",
        upImg: "arrow.png",
        refreshText: "正在加载数据...",
        refreshImg: "loading.png",
      }'>
        <no-data msg="没有更多数据了" v-if="pageLoaded"></no-data>
  
        <SkeletonScreen :data="5" v-show="!isCloseSkeletonScreen ||  (pageLoading && articel_list.length === 0)  " />
  
        <template v-for="(item, i) in articel_list">
          <li :key="item.id" v-if="item.state == 2" class="message_with_draw">
            你撤回了一条消息
          </li>
          <li
            v-if="item._time_firDate && item._time_firDateStamp && item.state != 2"
            :key="item.message_dialogue_time"
            class="message_dialogue_time"
            :data-time="item._time_firDate"
            :id="'made_' + item.id"
          ></li>
          <circleListItem
            v-if="item.state != 2"
            :circleData="circleData"
            :type="'app_circle'"
            :key="item.id"
            :msg="item"
            :index="i"
            :IsBlacklist="IsBlacklist"
            tagType="聊天室"
            :user_id="user_id"
            @chattingClick="chattingClickFn"
            :showChattingIndex="showChattingIndex"
            :isCloseInteraction="true"
            :liveDefault="liveDefault"
            :isAdmins="isAdmins"
          />
        </template>
  
        <div class="pd_zw_2" v-if="isCloseSkeletonScreen"></div>
      </drop-down-refresh>
      <!-- 滚动到底部的提示 -->
      <div class="h_agq_page_bottom_tip" v-if="is_show_bottom_tip" @click.stop.prevent="fixedBottom">聊天室有新消息更新，点击查看！</div>
  
      <!-- 输入框 -->
      <div class="publish_wrap">
        <div v-if="!focus_ipt" class="chattingRoomCheck">
          <button
            v-if="isAdmins && false"
            :class="['chatting_to_push_user', { bindThis: pushToUser }]"
            @click.stop.prevent="setPushToUser"
          >推送给成员</button>
          <button
              v-if="isAdmins"
              :class="['chat_banned_to_poast', {bindThis: circleData.chat_banned_to_post}]"
              @click.stop.prevent="openChatBannedToPost(circleData.chat_banned_to_post)"
          >
              {{ circleData.chat_banned_to_post? '关闭禁言' : '开启禁言' }}
          </button>
          <button :class="[{ bindThis: only_master_type }]" @click.stop.prevent="changeOnlyMasterFn">只看圈主</button>
        </div>
        <div class="publish_box" :class="{ publish_box_focus: focus_ipt }">
  
          <div
            class="publish_at"
            v-if="atUserId"
          >{{ atUserName }}: <span v-html="atUserContent"></span> <button
              class="closeBtn" @click.stop.prevent="closeAtFn"></button></div>
          <div class="publish_box_flex">
            <div class="input_box" :class="{ focus_ipt: focus_ipt }" @click.stop.prevent="handleClickComment">
              <div v-if="!focus_ipt">{{ comIptInfo }}</div>
              <textarea
                v-else ref="commentContent"
                cols="30"
                rows="10"
                :placeholder="comIptInfo"
                v-model="commentContent"
              ></textarea>
            </div>
            <div class="comment_wrap_app">
              <div class="comment_btn" @click="publishComment">发布</div>
            </div>
          </div>
        </div>
        <div class="pad" :class="{ is_iphonx_series: isIphonXSeries }"></div>
      </div>
      <div class="publish_mask" v-if="focus_ipt" @click.stop="() => {
          focus_ipt = false;
          commentContent = '';
        }
        "></div>
    </ul>
  </template>
  <script>
  import { Dialog } from "vant";
  import { u_id, token, appversion, source, change_bgImg, textSize } from "@/utils/urlQuery";
  import circleListItem from "@/page/appProfiles/components/circleListItem.vue";
  import dropDownRefresh from "@/page/appProfiles/components/dropDownRefresh.vue";
  import circleApi from "@/api/circle/index.js";
  import noResult from "@/page/appProfiles/components/no-result";
  import noData from "@/components/noData"
  import loading from "@/components/loading"
  // import banner from "@/page/appProfiles/components/banner";
  export default {
    name: "TabsChattingRoom",
    data() {
      return {
        articel_list: [],
        isCloseSkeletonScreen: false,
        // 页面载入情况
        pageLoaded: false,
        pageLoading: false,
        showChattingIndex: null,
        pageId: null,
        circleData: {},
        user_id: 0,
        id: Number(this.$route.params.chat_room_live_id || 0), // 圈子ID
        hasMore: false,
        IsBlacklist: 0, //审核状态 1为审核中，可拉黑
        commentContent: "",
        comIptInfo: "我也来聊两句…",
        focus_ipt: false,
        isIphonXSeries: this.$isIphonXSeries(),
        // at 用户信息
        atUserName: "",
        atUserId: "",
        atUserContent: "",
        ispublish: false,
        Vim: null,
        is_show_bottom_tip: false,
        // 只看圈主
        only_master_type: false,
        isAdmins: false,
        chattingRoomStyle: "",
  
        pushToUser: false, // 推送给用户
  
        hasBannerData: false,
        liveDefault: "list_msg",
        userInfo: {},
      }
    },
    components: {
      circleListItem,
      dropDownRefresh,
      noResult,
      noData,
      loading
      // banner
    },
    created() {
      // 初始化
  
      this.user_id = u_id;
      this.userInfo = { // 当前登录老师的信息
        user_app_token: token,
      };
      
      // 获取圈子列表
      this.getCircleInfo({ live_id: this.id, user_id: u_id }, () => {

        // 获取聊天室列表
        this.getChattingRoom();
      })
    },
    mounted() {
      // 监听页面是否重新打开
  
      // document.addEventListener("visibilitychange", function () {
        
      //     if (!document.hidden) {   //处于当前页面
      //       alert('轻轻的我来了' + new Date().getTime())
      //     } else {
      //       alert('重重的我走了' + new Date().getTime())
      //     }
      // });
      
  
  
      let _this = this;
  
      this.pushToUser = this.hasSaveInfo("pushToUserType_" + this.id);
  
      $(document).scroll(function () {
        let scroH = $(document).scrollTop();  //滚动高度
        let viewH = $(window).height();  //可见高度 
        let contentH = $(document).height();  //内容高度
  
        if (contentH < (scroH + viewH + 200)) {  //滚动条滑到底部啦
          _this.is_show_bottom_tip = false;
        }
      });
  
      // $("body").on("click", ".p-a-link", function (e) {
      //   e.stopPropagation();
      //   e.preventDefault();
      //   location.href = $(this).attr('href');
      // })
    },
    methods: {
      // 切换列表
      checkLiveDefault(type) {
        if (type == this.liveDefault) {
          return
        }
  
        this.liveDefault = type;
        this.only_master_type = false;
        this.pageId = null;
        this.pageLoaded = false;
        this.pageLoading = true;
  
        this.getChattingRoom(0);
      },
      // 跳转APP页面
      openNative(type, query = {}) {
          let params = {
              kind: type, // 类型
          };

          // 同步传参
          params = {
              ...params,
              ...query
          }
        this.$srH5CallNativeMethodApp('call_Native',params)
      },
      // 改变是否仅查看圈主
      changeOnlyMasterFn() {
        if (this.pageLoading) {
          return
        }
        let only_master_type = this.only_master_type;
        this.only_master_type = !only_master_type;
  
        this.pageId = null;
        this.pageLoaded = false;
        this.pageLoading = true;
  
        // 发送请求
        this.getChattingRoom();
      },
      // 开启禁言 - 关闭禁言
      openChatBannedToPost(type) {
          // https://lanhuapp.com/web/#/item/project/stage?pid=0d6b7c79-8094-4821-9b8e-025b025e27a4&tid=b1e3e92b-ef14-464a-911f-1fcb6605cac0&see=all
          let title = "", content ="";
          if(type == 0) {
              title = "确定要全体禁言吗？";
              content = "开启后，只允许老师发言"
          } else {
              title = "确定取消全体禁言吗？";
              content = "取消后，所有成员均可以发言"
          }
  
          let _that = this;
          Dialog.confirm({
              title: title,
              message: content,
          })
          .then(() => {
              _that.setChatBannedToPost({
                edit_val: type == 1? 0: 1,
                edit_type: "chat_banned_to_post"
              }, type)
          })
          .catch(() => {
              // on cancel
          });
      },
      // 操作聊天室是否禁言
      async setChatBannedToPost(opt, type) {
          let res = await circleApi.set_chat_room_status(opt);
  
          if(res.code == 1) {
              this.$message.success("操作成功");
              this.$set(this.circleData, 'chat_banned_to_post', type == 1? 0: 1)
          } else {
              this.$message.error(res.message);
          }
      },
      initSocket() {
        let _this = this;
        // 引入长连接
        this.jqLoadJs(["agq_pc/static/static/js/jquery.min.js?v=20230905164520217", "agq_pc/notifySocket/initSocket.js"], () => {
          // 初始化
          new newSocketNotify({ user_id: _this.user_id, token: _this.circleData.access_token }, 'app_notify', 'yes', (res) => {
            if (res.kind == "chat_banned_to_post") {
              let result = res.data.type;
              if (result == 1 || result == '1') {
                _this.$set(_this.circleData, 'chat_banned_to_post', 1)
                _this.comIptInfo = "全体禁言中";
              } else {
                _this.$set(_this.circleData, 'chat_banned_to_post', 0)
                _this.comIptInfo = "我也来聊两句…";
              }
            }
          })
        })
      },
      // 推送给成员
      setPushToUser() {
        this.pushToUser = !this.pushToUser
        if (this.pushToUser) {
          this.saveInfo("pushToUserType_" + this.id, "open_close")
        } else {
          this.saveInfo("pushToUserType_" + this.id, "close_type")
        }
      },
      // 获取用户聊天室的权限
      getChattingInfo(type) {
        let _this = this;
        let result = res.data;
        localStorage['ChattingToken'] = result;
  
        if (type == '_refresh') {
          _this.Vim && _this.Vim.reconnect && _this.Vim.reconnect()
        }
      },
      // 获取JS
      jqLoadJs(path, cb) {
        let url = "";
        if (path instanceof Array) {
          path = "/sr/??" + path.join();
        }
        let _current = "", _orign = window.location.origin;
        if (_orign.indexOf("http") > -1 && _orign.indexOf("//") > -1) {
          if (_orign.indexOf("dev") > -1 || _orign.indexOf("192.168.1.202") > -1) {
            _current = `https://cdn1dev.aigupiao.com`;
          } else if (_orign.indexOf("beta") > -1) {
            _current = `https://cdn1beta.aigupiao.com`;
          } else {
            _current = `https://cdn1.aigupiao.com`;
          }
        }
        console.info('path', path)
        url = `${_current}${path}?v=agq_${new Date().getTime()}`;
        console.info('url', url)
        $.ajax({
          url: url,
          dataType: "script",
          cache: true,
          success: function () {
            // console.log(`loadJS ok -> ${path}`);
            cb && cb();
          },
        });
      },
      // 获取圈子信息
      async getCircleInfo(opt, c) {
        // TOOD edit_2
        let res = await circleApi.get_chat_room_status(opt);
        if (res.code == 1) {
          let result = res.data;
          // {
          //   chat_banned_to_post: 0, // 禁言状态
          //   user_id: 44324, // 圈主ID
          //   master: 1, // 是否为老师
          //   id: this.id, // 聊天室ID
          //   chat_room_style: 0, // 聊天室类型
          //   name: "聊天室昵称", // 聊天室昵称
          // };
          this.circleData = result;
  
          // 聊天室类型
          this.chattingRoomStyle = result.chat_room_style == 1 ? 'live' : 'comment';

          // 
          this.openNative('document_title', {
            title: result.chat_room_title + '的聊天室'
          })
  
          // 初始化长连接
          // this.initSocket();
  
          let isAdmins = false;
          if(u_id == result.chat_room_user_id) {
              isAdmins = true
          }
  
          this.isAdmins = isAdmins;
  
  
          if (!isAdmins && result.chat_banned_to_post == 1 ? true : false) {
            this.comIptInfo = "全体禁言中"
          }
  
          c && c();
        } else {
          this.$message.error(res.message);
        }
      },
      // 下拉刷新
      async onRefresh(refreshDone) {
        this.pageLoading = true;
  
        await this.getChattingRoom(this.pageId);
        refreshDone();
      },
      // 聊天室点击事件
      chattingClickFn(obj) {
        console.info(obj.item, obj.index, obj.type)
  
        // 删除 撤回
        if (obj.type == 'delItem') {
          this.articel_list.splice(obj.index, 1);
          this.showChattingIndex = null;
        }
        // 点击某项展示 列表
        else if (obj.type == 'showTab') {
          if (this.showChattingIndex == obj.index) {
            this.showChattingIndex = null;
          } else {
            this.showChattingIndex = obj.index;
          }
        }
        // 回复某位用户
        else if (obj.type == 'reply_user') {
          this.replayUserFn(obj.item);
          this.handleClickComment();
        }
        // 关闭item
        else if (obj.type == 'closeItem') {
          this.showChattingIndex = null;
        }
      },
      // 获取聊天室列表
      async getChattingRoom(before_id) {
        this.pageLoading = true;
        let _this = this;
        let data = {
          chat_room_live_id: this.id,
          user_id: this.user_id,
          limit: 20,
          // is_show_admin_history: this.only_master_type ? 1 : 0,
        }
  
        if(this.only_master_type) {
          data.show_user_id = this.circleData.chat_room_user_id;
        }
  
        console.info('a1?')
  
        if (before_id) {
          data.before_id = before_id;
        }
  
        let method_name = 'get_chat_list';
  
        if (this.liveDefault == 'my_msg') {
          data.view_type = 3;
          method_name = "get_new_chat_list";
  
          if (this.chattingRoomStyle == 'comment') {
            data.limit_time = '1724817600'
            data.chat_room_style = 0;
          }
        }
        
        let res = await circleApi[method_name](data)
  
        if (res.code === 1) {
          let result = res.data && res.data.reverse();
  
          let _firstDom = $(
            ".articel_list li.message_dialogue_time"
          ).first();
  
          let _id = "" + $(_firstDom).attr('id')
  
          if (result && result.length > 0) {
  
            let _firData = new Date();
            if (result.length > 0) {
              let _date = result[0].create_time;
              _firData = new Date(_date.replace(/-/g, '/')).getTime();
              result[0]._time_firDate = _firData;
              result[0]._time_firDateStamp = _this.timeStamp(_date);
            }
  
            for (var i in result) {
              var qa = result[i];
              let item_date = qa.create_time;
              let qaDate = new Date(item_date.replace(/-/g, '/')).getTime()
              if (i > 0 && _firData * 1 + 600 * 1000 < qaDate) {
                _firData = qaDate;
                result[i]._time_firDate = qaDate;
                result[i]._time_firDateStamp = _this.timeStamp(item_date);
              }
            }
  
            if (!before_id) {
              _this.articel_list = result;
            } else {
              _this.articel_list.unshift(...result);
            }
  
            _this.pageId = result[0].id;
          } else {
            if (!before_id) {
              _this.articel_list = [];
            }
            _this.pageLoaded = true;
          }
  
          if (!before_id) {
            _this.isCloseSkeletonScreen = true;
            // 滚动到底部
            _this.$nextTick(() => {
              $("html, body").scrollTop(999999999);
            })
          } else {
            if ((result && result.length == 0) || !result) {
              _this.pageLoaded = true;
            } else {
              _this.$nextTick(() => {
                document.location.replace(_this.getFilterUrl(_id));
  
                _this.pageLoading = false;
              })
            }
          }
  
          if (!before_id && !_this.Vim) {
            _this.jqLoadJs(["agq_pc/static/static/js/jquery.min.js?v=20230905164520217", "pc/js/notifyCocket/initSocket.js"], () => {
              if (typeof agpInitSocket !== 'undefined' && agpInitSocket) {
                _this.Vim = new agpInitSocket({
                  circleInfo: _this.circleData,
                  userInfo: _this.userInfo, 
                  type: 'ChattingRoom', 
                  is_first: 'yes', 
                  c: (res) => {
                    console.info(res, 'socket——接收');
  
                    if (_this.articel_list && _this.articel_list.length > 0 && res && res.id == _this.circleData.chat_room_live_id) {
                      let count = 0;
                      let result = res.data;
  
                      // 插入
                      if (res.kind == "chat_room_send_message" || res.kind == 'chat_room_audit_message') {
                        if (_this.chattingRoomStyle == 'live') {
                          if (result.state > 0) {
                            return
                          }
                        } else if(!_this.isAdmins){
                          if (result.state > 0) {
                            return
                          }
                        }
                        for (let i = 0, ilen = _this.articel_list.length; i < ilen; i++) {
                          if (_this.articel_list[i].id == result.id) {
                            break;
                          }
  
                          count++;
                        }
  
                        console.info(count, _this.articel_list.length,'比对')
                        if (count === _this.articel_list.length) {
                          // 插入数据
                          _this.articel_list.push(result);
                          _this.$forceUpdate();
                          _this.$nextTick(() => {
                            let _show = _this.elementIsVisibleInViewport($('.circle_item').last()[0], true);
                            if (!_show) {
                              _this.is_show_bottom_tip = true;
                            }
                            else {
                              _this.$nextTick(() => {
                                $(_this.$refs['mouseWheelRf']).scrollTop(999999999);
                                $("html, body").scrollTop(999999999)
                              })
                            }
                          })
                        }
                      } else if(res.kind == 'chat_room_remove_message'){
                        for (let i = 0, ilen = _this.articel_list.length; i < ilen; i++) {
                          if (_this.articel_list[i].id == result) {
                            // 应该执行删除懂我意思吧？
                            _this.articel_list.splice(i, 1);
                            break;
                          }
                        }
                      }
                    }
                  }, 
                  refres: (res) => {
                    console.info("回调方法--》")
                    _this.getChattingInfo('_refresh')
                  }
                })
              }
            })
          }
        } else {
          _this.hasMore = false;
        }
        _this.pageLoading = false;
      },
      getFilterUrl(hash) {
        return document.location.protocol + '//' + document.location.host + document.location.pathname + document.location.search + '#' + hash;
      },
  
      // 实践方法
      timeStamp(data) {
        let _date = new Date(data.replace(/-/g, '/')),
          _now_date = new Date(),
          _today = new Date(
            _now_date.getFullYear(),
            _now_date.getMonth(),
            _now_date.getDate(),
            0,
            0,
            0,
            0
          ),
          _toyead = new Date(_now_date.getFullYear(), 0, 0, 0, 0, 0, 0);
  
        let _year = _date.getFullYear(),
          _month = _date.getMonth() + 1,
          _d = _date.getDate(),
          _h = _date.getHours(),
          _m = _date.getMinutes();
  
        if (_month < 10) {
          _month = "0" + _month;
        }
  
        if (_d < 10) {
          _d = "0" + _d;
        }
  
        if (_h < 10) {
          _h = "0" + _h;
        }
  
        if (_m < 10) {
          _m = "0" + _m;
        }
  
        // 今天的执行逻辑
        if (_date.getTime() > _today.getTime()) {
          return `${_h}:${_m}`;
        }
        // 今年的执行逻辑
        else if (_date.getTime() > _toyead.getTime()) {
          return `${_month}-${_d} ${_h}:${_m}`;
        }
        // 去年的执行逻辑
        else {
          return `${_year}-${_month}-${_d} ${_h}:${_m}`;
        }
      },
      handleClickComment() {
        if (this.focus_ipt || !this.isAdmins && this.circleData.chat_banned_to_post == 1 ? true : false) {
          return;
        }
        this.focus_ipt = true;

        this.$nextTick(()=>{
          this.$refs['commentContent'].focus();
        })
      },
      // 回复用户
      replayUserFn(item, index) {
        this.atUserName = item.nickname;
        this.atUserId = item.id;
        this.atUserContent = item.content;
      },
      // 关闭at用户
      closeAtFn() {
        this.atUserName = "";
        this.atUserContent = "";
        this.atUserId = "";
      },
      // 聊天室 - 发送内容
      async publishComment() {
        let _this = this;
        if (this.ispublish) {
          return;
        } else {
          this.ispublish = true;
          let content = this.commentContent;
          if (!content) {
            this.$message.error("请输入评论内容!");
            return (this.ispublish = false);
          }
          let data = {
            content,
            // user_id: this.user_id,
            chat_room_live_id: this.id,
            content_type: 1,
          };
  
          if (this.atUserName && this.atUserId) {
            data.origin_id = this.atUserId || 0;
          }
  
          if (this.isAdmins && this.pushToUser) {
            data.is_select_push = 1;
          }
  
          let res = await circleApi.send_message({
            ...data
          })
          if (res.code == 1) {
            _this.$message.success("发送成功");
  
            _this.focus_ipt = false;
            _this.commentContent = "";
            _this.ispublish = false;
            _this.showChattingIndex = null;
            _this.closeAtFn()
  
            let count = true;
            for (let i = 0, ilen = _this.articel_list.length; i < ilen; i++) {
              if (_this.articel_list[i].id == res.data.id) {
                count = false;
                break;
              }
            }
            if (count) {
              _this.articel_list.push(res.data);
            }
  
            _this.$nextTick(() => {
              $(_this.$refs['mouseWheelRf']).scrollTop(99999999999)
              $("html, body").scrollTop(99999999)
            })
          } else {
            _this.$message.error(res.message);
            _this.ispublish = false;
          }
        }
      },
      // 定位到底部
      fixedBottom() {
        $(this.$refs['mouseWheelRf']).scrollTop(99999999999)
        $("html, body").scrollTop(99999999)
        this.is_show_bottom_tip = false;
      },
      // 判断dom是否在可视区
      // 第一个参数是element  第二个参数是 是否部分可见也算可见  
      // 设置为false 即有一部份不可见即不可见
      // 设置为true 即部分可见即算是可见
      elementIsVisibleInViewport(el, partiallyVisible = false) {
        const {
          top,
          left,
          bottom,
          right
        } = el.getBoundingClientRect();
        const {
          innerHeight,
          innerWidth
        } = window;
        return partiallyVisible ?
          ((top >= 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) &&
          ((left >= 0 && left < innerWidth) || (right > 0 && right < innerWidth)) :
          top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
      },
      // 查询某个存储值是否存在
      hasSaveInfo(keys) {
        let _type = ""
        if (localStorage && localStorage[keys]) {
          _type = localStorage[keys]
        } else {
          _type = "close_type"
        }
  
        if (_type == 'close_type') {
          return false;
        } else {
          return true;
        }
      },
      saveInfo(keys, value) {
        if (localStorage) {
          localStorage[keys] = value;
        }
      }
    }
  }
  </script>
  <style scoped lang="scss">
  .articel_list {
    background: #F5F6F7;
    padding-top: 6px;
    overflow: hidden;
    position: relative;
  
    &.paddingTop {
      padding-top: 42px;
    }
  
    .h_agq_page_chatting_wrap_nav {
      width: 100%;
      height: 60px;
      background-color: #fff;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 2;
      padding: 10px 12px;
      box-sizing: border-box;
  
      div {
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        border-radius: 20px;
        overflow: auto;
  
        button {
          flex: 1;
          color: #939393;
          font-size: 14px;
          height: 100%;
          background-color: transparent;
          font-weight: bold;
          border: none;
          padding: 0;
          margin: 0 3px;
          outline: none;
          cursor: pointer;
  
          &.bind_this {
            height: calc(100% - 6px);
            background-color: #fff;
            margin: 3px;
            border-radius: 17px;
          }
        }
      }
    }
  
    .pd_zw {
      padding-top: 60px;
    }
  
    .pd_zw_2 {
      padding-top: 80px;
    }
  
    .chattingRoom {}
  
    .h_agq_page_li {
      &:last-of-type {
        margin-bottom: 90px;
      }
    }
  
    .chattingRoomBox {
      width: 100%;
      height: 76px;
      background-color: #fcfcfc;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      box-sizing: border-box;
      padding: 6.5px 10px;
  
  
  
      .chattingRoomIpt {
        height: 36px;
        position: relative;
      }
  
      .chattingRoomBoxIpt {
        width: 100%;
        height: 100%;
        background-color: #F2F2F2;
        border-radius: 2px;
        font-size: 15px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #939393;
        padding-left: 10px;
        box-sizing: border-box;
        user-select: none;
      }
  
      .chattingRoomBoxFace {
        width: 23px;
        height: 23px;
        position: absolute;
        right: 23.5px;
        top: 50%;
        transform: translateY(-50%);
  
        button {
          width: 23px;
          height: 23px;
          background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/face_app.svg");
          background-repeat: no-repeat;
          background-size: 23px 23px;
          background-color: transparent;
          border: none;
          outline: none;
        }
      }
    }
  
    .message_dialogue_time {
      width: 0;
      height: 0;
      overflow: hidden;
      visibility: hidden;
      opacity: 0;
    }
  
    // 撤回的消息样式
    .message_with_draw {
      width: 100%;
      height: auto;
      text-align: center;
      font-size: 12px;
      line-height: 16.5px;
      color: #888;
      padding: 10px 0;
      box-sizing: border-box;
    }
  }
  
  // 滚动到底部的提示
  .h_agq_page_bottom_tip {
    padding: 6px 26px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    background-color: #48A0FF;
    border-radius: 16.5px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 77.5px;
    cursor: pointer;
    user-select: none;
    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/down.svg");
    background-size: 10px 9.5px;
    background-position: 236px center;
    background-repeat: no-repeat;
    white-space: nowrap;
  }
  
  .publish_wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 20;
  
    .chattingRoomCheck {
      width: 100%;
      height: 27px;
      display: flex;
      align-items: center;
      background-color: #fff;
      padding-right: 10px;
      justify-content: flex-end;
      box-sizing: border-box;
  
      button {
        font-size: 12px;
        font-weight: normal;
        color: #636363;
        user-select: none;
        cursor: pointer;
        padding-left: 20px;
        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/check.svg");
        background-repeat: no-repeat;
        background-size: 13px 13px;
        background-color: transparent;
        background-position: left center;
        border: none;
        outline: none;
        cursor: pointer;
  
        &.bindThis {
          background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/chatting_room/checked.svg");
        }
  
        &.chat_banned_to_poast, &.chatting_to_push_user {
          margin-right: 20px;
        }
      }
    }
  
    .publish_box {
      width: 100%;
      height: auto;
      background: #ffffff;
      padding: 5px 10px;
      box-sizing: border-box;
      border-top: 1px solid #dedfde;
      border-bottom: 1px solid #dedfde;
  
      .publish_at {
        background-color: #fff;
        font-size: 13px;
        line-height: 18.5px;
        color: #636363;
        margin-bottom: 6.5px;
        padding-right: 87px;
        box-sizing: border-box;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-height: 37px;
  
        button {
          background-image: url("https://cdncos.aigupiao.com/assets/pc/svg/agq_common/h_agq_close.svg");
          width: 18.5px;
          height: 18.5px;
          background-repeat: no-repeat;
          background-size: 10px 10px;
          background-position: center center;
          position: absolute;
          right: 68.5px;
          padding: 0;
          background-color: transparent;
          border: none;
          outline: none;
        }
      }
  
      .publish_box_flex {
        width: 100%;
        height: auto;
        display: flex;
        box-sizing: border-box;
  
        >.input_box {
          flex: 1;
          height: 40px;
          border: 1px solid #dcdddc;
          color: #939393;
          border-radius: 5px;
          overflow: hidden;
  
          >textarea {
            width: 100%;
            height: 100%;
            color: #939393;
            border-radius: 5px;
            font-size: 15px;
            padding: 0 10px;
            box-sizing: border-box;
            border: none;
            outline: none;
            line-height: 40px;
            resize: none;
            background-color: #F2F2F2;
          }
  
          >div {
            width: 100%;
            height: 100%;
            color: #939393;
            border-radius: 5px;
            font-size: 15px;
            padding: 0 10px;
            box-sizing: border-box;
            border: none;
            outline: none;
            line-height: 40px;
            resize: none;
            background-color: #F2F2F2;
          }
  
          &.focus_ipt {
            height: 80px;
  
            >textarea {
              line-height: 25px;
            }
          }
        }
  
        >.comment_wrap_app {
          width: 54px;
          padding: 0 0 12px 9px;
          box-sizing: border-box;
          display: none;
          align-self: flex-end;
  
          .comment_btn {
            width: 46px;
            height: 36px;
            background: #fe484a;
            border: 1px solid #fe484a;
            border-radius: 5px;
            text-align: center;
            line-height: 36px;
            color: #fff;
            font-size: 12px;
          }
        }
      }
  
      &.publish_box_focus {
        height: auto;
  
        .comment_wrap_app {
          display: flex;
        }
      }
    }
  
    .pad {
      background: #ffffff;
  
      &.is_iphonx_series {
        padding-bottom: 20px;
      }
    }
  }
  
  .publish_mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.3);
  }
  </style>